
import { timeRangeOptions, saleOrderStatus, saleOrderType, stateOptionBoolean } from "@/utils/options";
const requestTypeOptions = [
    {id: 'NoRequest', text: '未请求'},
    {id: 'Fail', text: '请求失败'},
    {id: 'Success', text: '请求成功'}
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarketValue',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarketValue'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
}, {
    label: '状态',
    prop: 'orderStatusList',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'orderStatusList',
        propsData: {
            options: saleOrderStatus,
            placeholder: '全部状态',
            type: 'multi-check'
        }
    }],
    defaultValue: []
}, {
    label: '订单类型',
    prop: 'conditionOrderType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'conditionOrderType',
        propsData: {
            options: saleOrderType,
            placeholder: '全部订单类型'
        }
    }],
    defaultValue: ''
}, {
    label: '是否退货',
    prop: 'returned',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'returned',
        propsData: {
            options: stateOptionBoolean,
            placeholder: '是否退货'
        }
    }],
    defaultValue: ''
},{
    label: '是否退款',
    prop: 'refunded',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'refunded',
        propsData: {
            options: stateOptionBoolean,
            placeholder: '是否退款'
        }
    }],
    defaultValue: ''
}, {
    label: '请求评论',
    prop: 'requestReviewStatus',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'requestReviewStatus',
        propsData: {
            options: requestTypeOptions,
            placeholder: '请求评论'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: [
                {id: 'purchase', text: '订购时间'},
                {id: 'refunded', text: '退款时间'},
            ]
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'purchase'
}]
